<template>
  <div>
    <b-card>
      <div slot="header">
        {{ $lang.createSurveyGroupTerm }}
      </div>
      <LoadingSpinner :loading="loading" :text="$lang.sending_data" />
      <b-row v-show="!loading">
        <b-col cols="12" md="12">
          <b-form-group
            :label="`${$lang.selectTerm}: `"
            label-for="term"
            :label-cols="this.$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="`${$lang.selectTerm}: `"
              :rules="$v.term.$params"
            />
            <selectAsync
              :options="termOptions"
              v-model="$v.term.$model"
              label="caption"
              :asyncFind="getTermOptions"
              :loading="termLoading"
              :isValid="$v.term.$dirty ? !$v.term.$error : null"
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.term.$error ? 'block' : 'none',
              }"
              id="parvandeh_selected_feedback"
            >
              {{ $lang.error_required | replace($lang.selectTerm) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          class="text-right mt-3"
          v-if="
            includes('admin', parentPermissions) ||
            includes('edit', parentPermissions)
          "
        >
          <b-button variant="success" @click="submit">
            {{ $lang.submitButton }}
            <i class="fa fa-check"></i>
          </b-button>
          <b-button
            type="reset"
            class="ml-2"
            size="md"
            variant="danger"
            @click="close"
          >
            {{ $lang.close }}
            <i class="fa fa-ban"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { generateApiUrl, generateError, toastAlert } from "@/shared/utils";
import { getTermCombo } from "@/services";
import { createSurveyGroupTerm } from "@/modules/survey/services";

export default {
  components: { LoadingSpinner },
  props: {
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  validations: {
    term: { required },
  },
  data() {
    return {
      loading: false,
      code: this.$route.params.code,
      term: null,
      termOptions: [],
      termLoading: false,
    };
  },
  mounted() {
    this.getTermOptions();
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    close() {
      this.$emit("close");
    },
    async getTermOptions(text = null) {
      if (text) {
        this.termOptions = [];
      }

      try {
        this.termLoading = true;
        const response = await getTermCombo(text);
        const { options } = response;
        this.termOptions = options.map((option) => {
          return {
            ...option,
            id: pathOr(null, ["code"], option),
          };
        });
      } catch (error) {
        generateError(error);
      } finally {
        this.termLoading = false;
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      try {
        this.loading = true;
        const termCode = pathOr(null, ["id"], this.term);
        const response = await createSurveyGroupTerm(this.code, termCode);
        const { message } = response;
        toastAlert(message);
        this.close();
        this.$emit("getData");
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
